import axios from "axios"
import GlobalVariable from "./global"
const baseApiUrl = GlobalVariable.BASE_API_URL
const headerText = GlobalVariable.headerText

const DocusignTitle = 'You have received an email attachment from DocuSign. Please review and sign the document.'
const InvoicePaymentModes = [{ value: 1, label: 'WireTransfer' }, { value: 2, label: 'CreditCard' }, { value: 3, label: 'PayLater' }, { value: 4, label: 'GPay' }, { value: 5, label: 'ApplePay' }]
const InvoicePaymentStatus = [{ value: 1, label: 'Pending' }, { value: 2, label: 'Processed' }, { value: 3, label: 'Failed' }]
const WOStatus = [{ value: 1, label: 'Active' }, { value: 2, label: 'Cancelled' }, { value: 3, label: 'Archived' }]
const errorresponse = "Something Went Wrong. Please approach technical team."
const datesList = ["st", "nd", "rd", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th", "th", "st"]
const monthnames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
const fullmonthnames = [
  { key: '01', value: 'Jan' },
  { key: '02', value: 'Feb' },
  { key: '03', value: 'Mar' },
  { key: '04', value: 'Apr' },
  { key: '05', value: 'May' },
  { key: '06', value: 'Jun' },
  { key: '07', value: 'Jul' },
  { key: '08', value: 'Aug' },
  { key: '09', value: 'Sep' },
  { key: '10', value: 'Oct' },
  { key: '11', value: 'Nov' },
  { key: '12', value: 'Dec' }
]

const inspectionType = [
  { value: 87, label: "Ballast" },
  { value: 88, label: "ISM" },
  { value: 89, label: "ISPS" },
  { value: 90, label: "MLC" },
  { value: 91, label: "Preregistration" },
  { value: 92, label: "Safety" },
  { value: 93, label: "SSAS Verification" },
  { value: 113, label: "Additional" },
  { value: 114, label: "Annual" },
  { value: 115, label: "ILO - 92/133" },
  { value: 116, label: "Initial" },
  { value: 117, label: "Interim" },
  { value: 118, label: "Intermediate" },
  { value: 119, label: "Preemptive Boarding" },
  { value: 120, label: "Preregistration" },
  { value: 121, label: "Quarterly" },
  { value: 122, label: "Renewal" },
  { value: 123, label: "Special" },
  { value: 124, label: "Special Incident" },
  { value: 125, label: "Special Reduced" },
  { value: 126, label: "SSAS Verification" },
  { value: 384, label: "Detailed Inspection" },
  { value: 385, label: "More detailed inspection" },
  { value: 386, label: "Initial inspection" },
  { value: 389, label: "Expanded inspection" },
  { value: 462, label: "Law Enforcement" },
  { value: 492, label: "Preemptive Australia" },
  { value: 493, label: "Preemptive Australia Reduced" },
  { value: 494, label: "Preemptive Re-Inspection - Australia" },
  { value: 495, label: "Preemptive Re-Inspection - USA" },
  { value: 496, label: "Preemptive USA" },
  { value: 524, label: "Preemptive Inspection" },
  { value: 561, label: "Preemptive Paris MoU Free" },
  { value: 563, label: "Preemptive USA Free" },
  { value: 570, label: "Special Re-Inspection" },
  { value: 571, label: "Remote follow-up inspection" },
  { value: 575, label: "Current Detention" },
  { value: 589, label: "Preemptive Paris MoU" },
  { value: 590, label: "Preemptive Re-Inspection - Paris MOU" },
  { value: 592, label: "Special Monitoring (SSI)" },
  { value: 593, label: "Preemptive Tokyo MOU" },
  { value: 594, label: "Preemptive Tokyo MOU Free" },
  { value: 595, label: "Preemptive Re-Inspection – Tokyo MOU" },
  { value: 596, label: "Bi-Annual" },
  { value: 634, label: "Remote initial inspection" }
]

const inspectionStatus = [
  { value: 108, label: "Active" },
  { value: 109, label: "Approved" },
  { value: 110, label: "Completed" },
  { value: 111, label: "Scheduled" },
  { value: 112, label: "Submitted" },
  { value: 576, label: "Planning" }
]

const inspectionCAR = [
  { value: 646, label: "Complete" },
  { value: 647, label: "Follow up Requested" },
  { value: 648, label: "No Response" },
  { value: 649, label: "Overdue" },
  { value: 650, label: "Pending Response" },
  { value: 651, label: "Submitted" },
  { value: 816, label: "Not Received" },
  { value: 654, label: "Corrective Action Approved" },
  { value: 652, label: "Appeal Approved" },
  { value: 653, label: "Appeal Rejected" },
  { value: 655, label: "Non-Satisfactory Corrective Action" },
  { value: 656, label: "Pending" },
  { value: 657, label: "Pending Review" }
]

const addResponseInterceptor = async (axiosInstance) => {
  axiosInstance.interceptors.response.use((response) => {
    return response
  }, async function (error) {
    const originalRequest = error.config
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      const access_token = error.response.headers['x-auth-token']
      const refresh_token = error.response.headers['x-refresh-token']
      localStorage.setItem("token", access_token)
      localStorage.setItem("refresh_token", refresh_token)
      originalRequest.headers['Authorization'] = `Bearer ${access_token}`
      return axiosInstance(originalRequest)
    }
    return Promise.reject(error)
  })
}

export const DefaultConfig = () => {
  let authAxios
  let authAxiosMulti
  if (localStorage.getItem("userData")) {
    const localStorageToken = localStorage.getItem('token')
    const refreshToken = localStorage.getItem('refresh_token')
    authAxios = axios.create({
      baseURL: baseApiUrl,
      headers: { Authorization: `Bearer ${localStorageToken}`, "x-refresh-token": refreshToken },
      withCredentials: true
    })
    addResponseInterceptor(authAxios)
    authAxiosMulti = axios.create({
      baseURL: baseApiUrl,
      headers: {
        Authorization: `Bearer ${localStorageToken}`,
        "Content-Type": "multipart/form-data",
        "x-refresh-token": refreshToken
      },
      withCredentials: true

    })
    addResponseInterceptor(authAxiosMulti)
  }

  const sorter = (sortname, sortorder, filteredData) => {
    const sortData = filteredData
    sortData.sort((a, b) => {
      if (sortname === 'recordedDate' || sortname === 'createdDate' || sortname === 'modifiedDate' || sortname === 'startDate' || sortname === 'lastupdatedDate' || sortname === 'approvalDate') {
        if (sortorder === "asc") {
          return (a[sortname] ? new Date(a[sortname]) : a[sortname]) > (b[sortname] ? new Date(b[sortname]) : b[sortname]) ? 1 : (a[sortname] ? new Date(a[sortname]) : a[sortname]) < (b[sortname] ? new Date(b[sortname]) : b[sortname]) ? -1 : 0
        } else {
          return (b[sortname] ? new Date(b[sortname]) : b[sortname]) > (a[sortname] ? new Date(a[sortname]) : a[sortname]) ? 1 : (b[sortname] ? new Date(b[sortname]) : b[sortname]) < (a[sortname] ? new Date(a[sortname]) : a[sortname]) ? -1 : 0
        }
      } else {
        if (typeof a[sortname] === "number" && typeof b[sortname] === "number") {
          if (sortorder === "asc") {
            return parseFloat(a[sortname]) > parseFloat(b[sortname]) ? 1 : parseFloat(a[sortname]) < parseFloat(b[sortname]) ? -1 : 0
          } else {
            return parseFloat(b[sortname]) > parseFloat(a[sortname]) ? 1 : parseFloat(b[sortname]) < parseFloat(a[sortname]) ? -1 : 0
          }
        } else if (typeof a[sortname] === "string" && typeof b[sortname] === "string") {
          if (sortorder === "asc") {
            return a[sortname].toLowerCase() > b[sortname].toLowerCase() ? 1 : a[sortname].toLowerCase() < b[sortname].toLowerCase() ? -1 : 0
          } else {
            return b[sortname].toLowerCase() > a[sortname].toLowerCase() ? 1 : b[sortname].toLowerCase() < a[sortname].toLowerCase() ? -1 : 0
          }
        } else {
          if (sortorder === "asc") {
            return a[sortname] > b[sortname] ? 1 : a[sortname] < b[sortname] ? -1 : 0
          } else {
            return b[sortname] > a[sortname] ? 1 : b[sortname] < a[sortname] ? -1 : 0
          }
        }
      }
    })
    return sortData
  }

  const ReplaceString = (value) => {
    if (value) {
      return new Date(value.replace(/(\d+)(st|nd|rd|th)/, '$1'))
    }
    return ''
  }

  const DateFormat = (value) => {
    if (value) {
      const monthname = monthnames[new Date(value).getMonth()]
      const datevalue = `0${new Date(value).getDate()}`.slice(-2)
      const yearvalue = new Date(value).getFullYear()
      return `${datevalue}-${monthname}-${yearvalue}`
    } else {
      return ""
    }
  }

  const StringtoDateMonthYearFormat = (valueDate) => {
    if (valueDate) {
      const splitString = valueDate.split("-")
      if (splitString.length === 3) {
        const datevalue = splitString[0]
        const findMonth = fullmonthnames.find(find => find.key === splitString[1])
        let monthname = ''
        if (findMonth) {
          monthname = findMonth.value
        }
        const yearvalue = splitString[2]
        return `${datevalue}-${monthname}-${yearvalue}`
      }
    }
    return ""
  }

  const YearMonthDateFormat = (value) => {
    if (value) {
      const date = new Date(value)

      // Get the day, month, and year components
      let day = date.getDate()
      const monthIndex = date.getMonth()
      const year = date.getFullYear()
      if (day < 10) {
        day = `0${day}`
      }
      // Format the date
      const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

      return formattedDate
    }
    return ""
  }

  const DateConversion = (dateStr) => {
    if (dateStr) {
      // Create a Date object from the input string
      const date = new Date(dateStr)

      // Get the day, month, and year components
      let day = date.getDate()
      const monthIndex = date.getMonth()
      const year = date.getFullYear()
      if (day < 10) {
        day = `0${day}`
      }
      // Format the date
      const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

      return formattedDate
    }
    return ''
  }

  const DateTimeConversion = (dateStr) => {
    if (dateStr) {
      // Create a Date object from the input string
      const date = new Date(dateStr)
      // Get the day, month, and year components
      let day = date.getDate()
      const monthIndex = date.getMonth()
      const year = date.getFullYear()
      if (day < 10) {
        day = `0${day}`
      }
      // Format the date
      const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

      const formattedTime = date.toLocaleTimeString("en-US", {
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      })
      const formattedDateTime = `${formattedDate} ${formattedTime}`

      return formattedDateTime
    }
    return ''
  }

  const AmountFormat = (amount) => {
    if (isNaN(amount)) {
      return ''
    }
    let x = Number.parseFloat(amount).toFixed(2)
    const sign = x.startsWith('-') ? '-' : ''
    x = x.replace('-', '')
    const parts = x.split('.')
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return sign + parts.join('.')
  }

  const selectStyles = {
    container: (provided) => ({
      ...provided,
      marginTop: 0
    }),
    valueContainer: (provided) => ({
      ...provided,
      overflow: "visible"
    }),
    placeholder: (base, state) => ({
      ...base,
      position: "absolute",
      top: (state.hasValue || state.selectProps.inputValue || state.selectProps.menuIsOpen) ? '-45%' : '20%',
      transition: 'top 0.2s, font-size 0.2s',
      fontSize: (state.hasValue || state.selectProps.inputValue || state.selectProps.menuIsOpen) && 14,
      background: "#fff",
      padding: "0 5px",
      fontWeight: 500,
      color: '#000'
    })
  }

  const formatYearDate = (date) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const emailDurationTime = 30 * 1000
  const zoomInOut = { animate: { opacity: 1, scale: 1 }, transition: { duration: 1, delay: 0.1 }, initial: { opacity: 0, scale: 0.5 }, exit: { opacity: 0, scale: 0.5 } }
  const leftToRight = { animate: { x: 0 }, transition: { type: 'slide', stiffness: 120 }, initial: { x: '-100%' }, exit: { x: '100%' } }
  const CreditCardpercentage = 0.04
  const CreditCardNote = 'Please note that a 4% Convenience Fee is charged based on the transaction total'

  return {
    headerText,
    selectStyles,
    DocusignTitle,
    InvoicePaymentModes,
    InvoicePaymentStatus,
    WOStatus,
    errorresponse,
    authAxios,
    authAxiosMulti,
    sorter,
    datesList,
    monthnames,
    DateFormat,
    YearMonthDateFormat,
    AmountFormat,
    StringtoDateMonthYearFormat,
    DateTimeConversion,
    DateConversion,
    ReplaceString,
    emailDurationTime,
    zoomInOut,
    leftToRight,
    formatYearDate,
    CreditCardpercentage,
    CreditCardNote,
    inspectionType,
    inspectionStatus,
    inspectionCAR
  }
}
